// Import react lib
import { createContext, useState, useEffect } from 'react';

// Import database API
import { getUserChangeSubscriber } from '../services/auth';

// Create the context
export const AuthContext = createContext();

const ADMIN_ID = process.env.REACT_APP_ADMIN_USER_ID;

export function AuthProvider({ children }) {
    // Store the user into a state
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Every time the commponent is mounted, reset the user state
        setUser(null);
        setIsAdmin(false);
        setIsLoading(true);

        // Get a subscriber on user changes
        const onUserChangeSubscriber = getUserChangeSubscriber((newUser) => {
            setIsLoading(true);
            setUser(newUser);
            setIsAdmin(newUser?.id === ADMIN_ID);
            setIsLoading(false);
        });

        // When the component is unmounted unsubscribe to user changes
        return () => {
            onUserChangeSubscriber.unsubscribe();
        };
    }, []);

    // Return the context provider
    return (
        <AuthContext.Provider value={{ user, isAdmin, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
}
